import {Message, Notification} from 'element-ui'
import store from '@/vuex'
import axios from 'axios'
import httpConfig from "../../http/config";
import router from '@/router'

export default {
  axios() {
    axios.defaults.headers.common['Authorization'] =
      store.state.adminLogin.token_type + ' ' + store.state.adminLogin.access_token
    return axios.create(httpConfig);
  },
  getData(url, data) {
    let http = this.axios();
    return new Promise((resolve, reject) => {
      http.get(url, {params: data}).then(resolve).catch(res => {
        switch (res.response.status) {
          case 500:
            Message.error('获取数据失败! ')
            break;
          case 401:
            Message.error('重新登录!');
            router.push({
              name:"Login"
            });
            break;
          case 403:
            Notification.error(res.response.data.message || '抱歉，您没有权限');
            break;
          default:
            Message.error(res.data.result.message || '获取数据失败! ')
        }
        reject(res);
      })
    })
  },
  postData(url, data) {
    let http = this.axios();
    return new Promise((resolve, reject) => {
      http.post(url, data).then(res => {
        console.log("操作成功");
        resolve(res.data)
      }).catch(res => {
        if (res.response.status == 500) {
          Message.error('提交数据失败! ')
        } else if (res.response.status == 403) {
          Notification.error(res.response.data.message || '抱歉，您没有权限');
        } else if (res.response.status == 422) {
          Message.error(res.data.result.message);
        } else {
          Message.error(res.data.result.message || '获取数据失败! ')
        }
        reject(res);
      })
    })
  },
  putData(url, data) {
    let http = this.axios();
    return new Promise((resolve, reject) => {
      http.put(url, data).then(res => {
        console.log("操作成功");
        resolve(res.data)
      }).catch((res) => {
        if (res.response.status == 500) {
          Message.error('提交数据失败! ')
        } else if (res.response.status == 403) {
          Notification.error(res.response.data.message || '抱歉，您没有权限');
        } else if (res.response.status == 422) {
          Message.error(res.data.result.message);
        } else {
          console.log(res.response);
        }
        reject(res.response);
      })
    })
  },
  deleteData(url, data) {
    let http = this.axios();
    return new Promise((resolve, reject) => {
      http.delete(url, data).then(res => {
        resolve(res.data)
      }).catch(res => {
        if (res.response.status == 500) {
          Message.error('删除失败! ')
        } else if (res.response.status == 403) {
          Notification.error(res.response.data.message || '抱歉，您没有权限');
        } else if (res.response.status == 422) {
          Message.error(res.data.result.message);
        } else {
          Message.error(res.data.result.message || '删除失败! ')
        }
        reject(res);
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/lib/admin/http/index.js